import * as React from "react";
const SvgArrowback = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <path
      fill="#191919"
      fillRule="evenodd"
      d="M17.018 11.526a.8.8 0 1 1 1.289.948L17.663 12l.644.474-.002.002-.003.004-.01.014-.04.054-.15.197a39.159 39.159 0 0 1-2.568 2.977c-1.64 1.714-3.9 3.742-6.225 4.716a.8.8 0 0 1-.618-1.476c2.006-.84 4.077-2.663 5.686-4.345a38 38 0 0 0 2.457-2.85q.093-.119.14-.182l.034-.046.008-.01z"
      clipRule="evenodd"
    />
    <path
      fill="#191919"
      fillRule="evenodd"
      d="M17.018 27.874a.8.8 0 0 0 1.289-.948l-.644.474.644-.474-.002-.002-.003-.004-.01-.015-.04-.053-.15-.197a39.192 39.192 0 0 0-2.568-2.977c-1.64-1.714-3.9-3.742-6.225-4.716a.8.8 0 1 0-.618 1.476c2.006.84 4.077 2.663 5.686 4.346a38 38 0 0 1 2.457 2.848l.14.183.034.046.008.01z"
      clipRule="evenodd"
    />
    <path
      fill="#191919"
      fillRule="evenodd"
      d="M8.2 19.7a.8.8 0 0 1 .8-.8h20.9a.8.8 0 0 1 0 1.6H9a.8.8 0 0 1-.8-.8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowback;
